export const TEXTS = {
  SBER_BUSINESS_ONLINE_ACCEPTANCE_ADVANCED_ERROR: 'Ошибка при подписании Согласия на списание. Повторите попытку',
  SBER_BUSINESS_ONLINE_ACCEPTANCE_ADVANCED_CREATED:
    'Процесс подписания Согласия на списания запущен. Пройдите в Личный кабинет СберБизнес',
  SBER_BUSINESS_ONLINE_ACCEPTANCE_ADVANCED_PENDING: 'Проверяем статус подписания Согласия на списание. Ожидайте',
  SBER_BUSINESS_ONLINE_ACCEPTANCE_ADVANCED_TOO_LONG:
    'Статус согласия на списание средств все еще неактивен. Проверьте состояние подписки в личном кабинете СберБанк Бизнес',
  SBER_BUSINESS_ONLINE_ACCEPTANCE_ADVANCED_CANCELLED: 'Согласие на списание средств отменено. Подпишите заново',
  SBER_BUSINESS_ONLINE_ACCEPTANCE_ADVANCED_ACTIVE_TRIAL:
    'Согласие подписано. Необходимая сумма будет списываться автоматически по завершению тестового периода',
  SBER_BUSINESS_ONLINE_ACCEPTANCE_ADVANCED_ACTIVE:
    'Согласие подписано. Необходимая сумма будет списываться автоматически',
};
